import {EopModalDialog} from "./modalDialog";
import {resolve} from "../../../container";
import {PageScrollbar} from "../../../common/pageScrollbar";
import {EventBus} from "../../../common/eventBus";
import {TriggerService} from "../../../common/trigger/triggerService";
import {DialogActivation} from "./dialogActivation";
import {LocalStorage} from "../../../common/clientStorage";

export const CLEANUP_DIALOG_EVENT = "closeDialog";
const MILLIS_OF_90_DAYS = 1000 * 60 * 60 * 24 * 90;

interface ClientStorageStatus {
    enabled?: boolean;
}

export class BootStrapDialogOpener {

    private clientStorageKey: string | undefined;

    public constructor(
        private dialogElement: EopModalDialog,
        eventBus: EventBus = resolve(EventBus),
        private pageScrollbar: PageScrollbar = resolve(PageScrollbar),
        private triggerService: TriggerService = resolve(TriggerService),
        private localStorage: LocalStorage = resolve(LocalStorage)
    ) {
        eventBus.on(CLEANUP_DIALOG_EVENT, () => this.cleanUp());

        const dataTrigger = dialogElement.getAttribute("data-trigger");
        if (dataTrigger) {
            this.bootStrap();
        }
    }

    private bootStrap(): void {
        this.clientStorageKey = this.dialogElement.getAttribute("client-storage-key") ?? undefined;
        const activation = new DialogActivation(this.dialogElement);
        const openDialog = (): void => {
            if (!this.isEnabledAccordingToStorage()) {
                return;
            }
            this.openDialog(new Event("bootstrapdialog"));
        };

        this.triggerService.forEvent(this.dialogElement.getAttribute("data-trigger") ?? undefined)
            .createTrigger(this.dialogElement, () => activation.ifActive(openDialog));
    }

    public openDialog(e: Event): void {
        if (e instanceof KeyboardEvent && e.key !== "Enter") {
            return;
        }
        this.pageScrollbar.disablePageScrollability();
        void this.dialogElement.showModal();
        this.disablePersistently();
    }

    private cleanUp(): void {
        this.pageScrollbar.enablePageScrollability();
    }

    private isEnabledAccordingToStorage(): boolean {
        if (!this.clientStorageKey) {
            return true;
        }
        const storageContent = this.localStorage.fetch<ClientStorageStatus>(this.clientStorageKey);
        return storageContent?.enabled ?? true;
    }

    private disablePersistently(): void {
        if (!this.clientStorageKey) {
            return;
        }
        const storageData: ClientStorageStatus = {enabled: false};
        const date90DaysInFuture = new Date().getTime() + MILLIS_OF_90_DAYS;
        this.localStorage.save(this.clientStorageKey, storageData, {until: date90DaysInFuture});
    }
}
